/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dataStates.vue?vue&type=template&id=5b0e1244&scoped=true&"
import script from "./dataStates.vue?vue&type=script&lang=js&"
export * from "./dataStates.vue?vue&type=script&lang=js&"
import style0 from "./dataStates.vue?vue&type=style&index=0&id=5b0e1244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e1244",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VChip,VCol,VDataTable,VDialog,VIcon,VRow})
